import React, { FC } from 'react';
import { BtnDefault } from './Buttons';
import { RxCross2 } from 'react-icons/rx';
import { useThemeStore } from '../../state/theme';

interface SideModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: React.ReactNode;
}

const SideModal: FC<SideModalProps> = ({
  isOpen,
  onClose,
  children,
  title = '',
}) => {
  const { isDarkMode } = useThemeStore();

  return (
    <div
      className={`fixed inset-0 z-50 transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
      aria-hidden={!isOpen}
      style={{ margin: 0 }}
    >
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 transition-opacity ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={onClose}
      ></div>

      {/* Modal Content */}
      <div
        className={`absolute right-0 top-0 h-full w-[50%] ${
          isDarkMode ? 'bg-gray-800' : 'bg-white'
        } shadow-xl p-6`}
        role="dialog"
      >
        <div className="flex mb-6 justify-between items-center">
          <div className={`${isDarkMode ? 'text-white' : 'text-black'}`}>
            {title}
          </div>
          <BtnDefault
            onClick={onClose}
            className="flex items-center gap-1"
            aria-label="Close modal"
          >
            <RxCross2 /> Close
          </BtnDefault>
        </div>
        {children}
      </div>
    </div>
  );
};

export default SideModal;
